import React from 'react';
import styles from './Search.module.css';

export default class Search extends React.Component {
  onSubmit = () => {
    const value = this.refs.search.value;
    const { onAction } = this.props;
    if (onAction) onAction(value);
  };

  render() {
    const placeholder = this.props.placeholder || 'Search';
    return (
      <div className={styles.searchContainer}>
        <img
          alt="search"
          src="/img/search.svg"
          className={styles.searchIcon}
          onClick={this.onSubmit}
        />
        <input
          ref="search"
          className={styles.search}
          onKeyPress={e => {
            if (e.key === 'Enter') this.onSubmit();
          }}
          placeholder={placeholder}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Search/index.js